import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { ScreenRecordPromoBanner, ScreenRecordPromoModal } from '@/widgets/createProject';
import { TrialPricingModal } from '@/widgets/pricing/pricingCards';
import { TeamspaceSettingsModal } from '@/widgets/teamspaceSettings';

import { BookACallModal } from '@/features/bookACall';
import { IntroduceBoostersModal, ManageBoostersModal, useBoostersPromo } from '@/features/boosters';
import { DebugMenu, useDebugMenuHotkey } from '@/features/debugMenu';
import { NewUserQuizGate } from '@/features/newUserQuiz';
import { BuyMinutesModal } from '@/features/pricing/buyMinutes';
import { CancelPauseModal, useCancelPauseModalStore } from '@/features/pricing/cancelPause';
import { DowngradeConfirmationModal } from '@/features/pricing/downgradeConfirmation';
import { TrialPaywall } from '@/features/pricing/trialPaywall/ui';
import { UpgradeConfirmationModal } from '@/features/pricing/upgradeConfirmation';
import { RecordingFeedbackBonusModal } from '@/features/recordingFeedbackBonus';
import { RecordingShareModal } from '@/features/recordingShare';
import { useScreenRecordPromo, useScreenRecordPromoBanner } from '@/features/screenRecordPromo';
import { TeamspaceWelcomeModal, useIsSpaceOwner } from '@/features/teamspace';

import { AfterPurchaseModal } from '@/entities/afterPurchase';
import { usePendingPaymentSessionLifecycle } from '@/entities/paymentSession';
import { EnterprisePaymentRequiredModal, UpgradePlanModal } from '@/entities/pricing';
import { PurchaseConfirmationModal } from '@/entities/purchaseConfirmation/ui/PurchaseConfirmationModal';

import { useHandlePaymentSuccess } from './hooks/useHandlePaymentSuccess';

const BaseLayoutContent = () => {
  const isSpaceOwner = useIsSpaceOwner();
  const openCancelPauseModal = useCancelPauseModalStore((state) => state.open);

  useHandlePaymentSuccess();
  useBoostersPromo();
  useScreenRecordPromo();
  useScreenRecordPromoBanner();
  useDebugMenuHotkey();
  usePendingPaymentSessionLifecycle();

  return (
    <>
      <Outlet />
      <UpgradePlanModal isSpaceOwner={isSpaceOwner} />
      <UpgradeConfirmationModal />
      <DowngradeConfirmationModal />
      <EnterprisePaymentRequiredModal />
      <IntroduceBoostersModal />
      <PurchaseConfirmationModal />
      <AfterPurchaseModal />
      <ManageBoostersModal onOpenCancelPause={openCancelPauseModal} />
      <BuyMinutesModal />
      <TeamspaceSettingsModal />
      <TeamspaceWelcomeModal />
      <TrialPaywall />
      <TrialPricingModal />
      <CancelPauseModal />
      <ScreenRecordPromoModal />
      <ScreenRecordPromoBanner />
      <RecordingFeedbackBonusModal />
      <RecordingShareModal />
      <BookACallModal />
      <DebugMenu />
    </>
  );
};

export const BaseLayout = () => (
  <Suspense>
    <NewUserQuizGate>
      <BaseLayoutContent />
    </NewUserQuizGate>
  </Suspense>
);
